import Filters from "components/Filters";
import { onUseEffect } from "components/generators/filtersGenerator";
import withCollapse from "hocs/withCollapse";
import { FilterField } from "layout/TableConstructor/types";
import qs from "qs";
import { useEffect, useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

type ListFiltersProps = {
  form: UseFormReturn;
  filters: FilterField<object>[];
};

const CollapsedFilters = withCollapse(Filters);

const ListFilters = ({ form, filters }: ListFiltersProps) => {
  const { reset } = form;
  const [searchParams] = useSearchParams();
  const query = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);

  useEffect(() => {
    onUseEffect(filters, reset, query);
  }, [query]);

  return (
    <CollapsedFilters
      form={form}
      filters={filters}
      hiddenText='показать фильтры'
      expandedText='скрыть фильтры'
    />
  );
};

export default ListFilters;
